module.exports = __webpack_public_path__ + "static/media/love_2.b1eb4a71.jpg";